/**
 * obtain computed value of a CSS custom property
 * works with properties that can e applied to a width
 */
export const getComputedDimensionFromCustomProperty = (
    element: HTMLElement,
    propertyName: string,
    asInt: boolean = false
): string | number => {
    const propertyValue = getComputedStyle(element).getPropertyValue(propertyName);
    const tmpElement = document.createElement("div");
    tmpElement.style.width = propertyValue;
    document.body.appendChild(tmpElement);
    const width = getComputedStyle(tmpElement).getPropertyValue("width");
    tmpElement.remove();
    return asInt ? Math.round(parseFloat(width)) : width;
};
